import { DateTime } from "luxon";

/**
 * Converts UNIX Time into hh:mm:ss A
 */
export const toDisplayableTime = seconds => {
  if (typeof seconds === "string") return seconds;
  try {
    return DateTime.utc()
      .startOf("day")
      .plus({ seconds })
      .toFormat("hh:mm:ss a");
  } catch (e) {
    return seconds;
  }
};
